export enum Icons {
  ActiveOrdersNew = 'active-orders_new',
  Adjust = 'adjust',
  Android = 'android',
  ApplePay = 'apple-pay',
  Apple = 'apple',
  ArrowHalf = 'arrow-half',
  ArrowTop = 'arrow-top',
  Back = 'back',
  Bell = 'bell',
  BranchesTree = 'branches-tree',
  Calendar = 'calendar',
  CallCenter = 'call-center',
  Car = 'car',
  Card = 'card',
  Cash = 'cash',
  Cashback = 'cashback',
  Categories = 'categories',
  Chat = 'chat',
  Check = 'check',
  Checkout = 'checkout',
  Chevron = 'chevron',
  Circle = 'circle',
  Clock = 'clock',
  CloseCircle = 'close-circle',
  CloseSmall = 'close-small',
  Close = 'close',
  Cluster = 'cluster',
  ConsumerChannelKiosk = 'consumer-channel-kiosk',
  ConsumerChannelMobile = 'consumer-channel-mobile',
  ConsumerChannelWeb = 'consumer-channel-web',
  Conversation = 'conversation',
  Copy = 'copy',
  Curbside = 'curbside',
  Customers = 'customers',
  Dashboard = 'dashboard',
  DateTime = 'date-time',
  Delivery = 'delivery',
  DineIn = 'dine-in',
  Disguise = 'disguise',
  DookSecondary = 'dook-secondary',
  DragHandHorizontal = 'drag-hand-horizontal',
  DragHand = 'drag-hand',
  Edit = 'edit',
  Email = 'email',
  Exclusions = 'exclusions',
  ExpandLeft = 'expand-left',
  ExpandRight = 'expand-right',
  FileDrag = 'file-drag',
  Filter = 'filter',
  Foodics = 'foodics',
  Geo = 'geo',
  Gift = 'gift',
  Globe = 'globe',
  Hand = 'hand',
  HintArrow = 'hint-arrow',
  IcArrow = 'ic_arrow',
  IcCareem = 'ic_careem',
  IcDookApp = 'ic_dook_app',
  IcDookCash = 'ic_dook_cash',
  IcDookOnline = 'ic_dook_online',
  IcGift = 'ic_gift',
  IcHungerStation = 'ic_hunger_station',
  IcJahez = 'ic_jahez',
  IcKeeta = 'ic_keeta',
  IcMiniDook = 'ic_MiniDook',
  IcToYou = 'ic_to_you',
  IcDook = 'icDook',
  Info = 'info',
  Items = 'items',
  Kiosk = 'kiosk',
  Link = 'link',
  Logout = 'logout',
  ManagementCar = 'management_car',
  MapLocation = 'map-location',
  Map = 'map',
  Marketplace = 'marketplace',
  Marn = 'marn',
  Megafon = 'megafon',
  Menu_1 = 'menu-1',
  MenuDots = 'menu-dots',
  MenuGroups = 'menu-groups',
  Menu = 'menu',
  Minus = 'minus',
  Modifiers = 'modifiers',
  NoResults = 'no-results',
  Ok = 'ok',
  OrdersHistory = 'orders-history',
  Pause = 'pause',
  Pdf = 'pdf',
  Pencil = 'pencil',
  Pin = 'pin',
  Plus = 'plus',
  Products = 'products',
  QrCode = 'qr_code',
  Rating = 'rating',
  Reports = 'reports',
  Reset = 'reset',
  ReverseArrows = 'reverse-arrows',
  Search = 'search',
  SelectedMapLocation = 'selected-map-location',
  SelectedPin = 'selected-pin',
  Settings = 'settings',
  ShoppingBag = 'shopping-bag',
  SliderLeft = 'slider-left',
  SliderRight = 'slider-right',
  Smile = 'smile',
  Spinner = 'spinner',
  Swap = 'swap',
  Taker_360 = 'taker_360',
  TakerConnect = 'taker_connect',
  TakerGo = 'taker_go',
  Terminal = 'terminal',
  Text = 'text',
  TimeLeft = 'time-left',
  Trash = 'trash',
  UnDisguise = 'un-disguise',
  Wallet = 'wallet',
  Warning = 'warning',
}
